import { jsx as _jsx } from "react/jsx-runtime";
var BAR_SPACER = "flex flex-grow";
export var BarSpacer = function () { return _jsx("span", { className: BAR_SPACER }, void 0); };
